const initialState = {
  isAccountDeletable: {},
  requestAccDeletionResp: {},
  accountDeletionError: '',
  errorDeleteAccount: ''
};

const DeleteAccountReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ACCOUNT_DELETION_CHECK':
      return { ...state, isAccountDeletable: action.payload };
    case 'ACCOUNT_DELETION_REQUEST':
      return { ...state, requestAccDeletionResp: action.payload };
    case 'ACCOUNT_DELETION_ERROR':
      return { ...state, accountDeletionError: action.error };
    case 'RESET_ACCOUNT_DELETION':
      return {
        ...state,
        accountDeletionError: '',
        isAccountDeletable: {},
        requestAccDeletionResp: {}
      };
    case 'ERROR_DELETE_ACCOUNT':
      return { ...state, errorDeleteAccount: action.payload };
    default:
      return state;
  }
};

export default DeleteAccountReducer;
